import { defineMessages } from 'react-intl';

export const sessionDateDisplayMessages = defineMessages({
  tomorrow: {
    defaultMessage: 'Tomorrow',
    id: 'xugc2xf854',
    description: 'Relative date label for the next calendar day',
  },
  today: {
    defaultMessage: 'Today',
    id: '1NmBcpfWyo',
    description: 'Relative date label for the current calendar day',
  },
  yesterday: {
    defaultMessage: 'Yesterday',
    id: 'GnDIZi7wV9',
    description: 'Relative date label for the previous calendar day',
  },
  xDaysAgo: {
    defaultMessage: '{count, plural, one {# day ago} other {# days ago}}',
    id: 's2m5m0+Ud9',
    description: 'Relative date label for a date within the past week',
  },
  aWeekAgo: {
    defaultMessage: '1 week ago',
    id: 'aGDA0YNEcU',
    description: 'Relative date label for exactly seven days ago',
  },
});
